
export const months = ["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];

export const days = ["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"]